export default function wehookReducer(webhook, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "customHeader.name":
      return { ...webhook, customHeader: { ...webhook.customHeader, name: action.value } };
    case "customHeader.value":
      return { ...webhook, customHeader: { ...webhook.customHeader, value: action.value } };
    case "migrateToModernWebhook":
      return {
        ...webhook,
        useNewWebhooks: true,
        enabled: true,
      };

    default:
      return { ...webhook, [action.type]: action.value };
  }
}
